import api from "./BaseServices";

export interface FollowRelationShips {
  user_id: number;
  followed_user_id: number;
  affinity_score: string;
  followed_at: Date;
}

const API_URL = `${process.env.REACT_APP_API_URL}/follow`;

// 🔄 Follow a user by ID (uses logged-in user from cookies/session)
export const followUser = async (
  userId: number
): Promise<FollowRelationShips> => {
  const response = await api.post(`${API_URL}/${userId}/follow`, null, {
    withCredentials: true,
  });
  return response.data;
};

// 🚫 Unfollow a user by ID (uses logged-in user from cookies/session)
export const unfollowUser = async (userId: number): Promise<void> => {
  await api.post(`${API_URL}/${userId}/unfollow`, null, {
    withCredentials: true,
  });
};

// 👀 Get list of followers for a given user ID
export const getNbFollowers = async (followedId: number): Promise<number> => {
  const response = await api.get(`${API_URL}/${followedId}/Nbfollowers`);
  return response.data;
};

// 👀 Get list of followers for a given user ID
export const getNbFollows = async (followedId: number): Promise<number> => {
  const response = await api.get(`${API_URL}/${followedId}/Nbfollows`);
  return response.data;
};

// 🧾 Get list of users the logged-in user is following
export const getFollows = async (
  followerId: number,
  limit: number,
  offset: number
): Promise<{
  followsList: { id: number; username: string }[];
  nbFollows: number;
}> => {
  const response = await api.get(`${API_URL}/${followerId}/follows`, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};

export const checkIsFollowing = async (
  followedId: number
): Promise<boolean> => {
  const response = await api.get(`${API_URL}/${followedId}/isFollowing`);
  return response.data;
};
